import {HttpParams} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Params} from '@angular/router';
import {Observable} from 'rxjs';
import {buildQueryParamsFrom} from '@aviary/store/common/list-data.helpers';
import {ListData} from '@aviary/store/common/common.types';
import {MakeAPaymentValue, PatronBalanceTransaction, SquareAppDetails} from './balance.types';
import {ApiService} from '@aviary/services/api.service';
import {extractPropertiesByKeyFrom} from '@aviary/store/transformation.helpers';
import {CreatePaymentBody} from '@store/balance/balance.api-types';
import {contextWithErrorHandlerForSubmitMakeAPayment} from '@store/balance/balance.handlers';

@Injectable({providedIn: 'root'})
export class BalanceService {

  private readonly apiService: ApiService = inject(ApiService);

  public loadBalanceTransactions(queryParams: Params, includeAllTransactions: boolean): Observable<ListData<PatronBalanceTransaction>> {
    const endpoint: string = 'patrons/v3/patrons/account/transactions';

    const params: HttpParams = buildQueryParamsFrom({
      ...queryParams,
      onlyOutstanding: !includeAllTransactions
    });

    return this.apiService.getListData(endpoint, {params});
  }

  public loadSquareAppDetails(): Observable<SquareAppDetails> {
    const endpoint: string = 'patrons/v2/payments/square/app-details';

    return this.apiService.getSingleObject(endpoint);
  }

  public submitMakeAPayment(value: MakeAPaymentValue): Observable<PatronBalanceTransaction> {
    const endpoint: string = 'patrons/v2/payments';
    const body: CreatePaymentBody = extractPropertiesByKeyFrom(value, 'token', 'amount');

    return this.apiService.postAndReturnSingleObject(endpoint, body, {context: contextWithErrorHandlerForSubmitMakeAPayment()});
  }

  public submitMakeAPaymentForDependent(value: MakeAPaymentValue, dependentPatronId: number): Observable<PatronBalanceTransaction> {
    const endpoint: string = `patrons/v2/dependents/payment/${dependentPatronId}`;
    const body: CreatePaymentBody = extractPropertiesByKeyFrom(value, 'token', 'amount');

    return this.apiService.postAndReturnSingleObject(endpoint, body, {context: contextWithErrorHandlerForSubmitMakeAPayment()});
  }
}
